import React from 'react';

import { Icon, Translate } from '@hydra/common/components';
import StyleButton from './StyleButton';

// Available INLINE_STYLES:
// { label: 'Underline', style: 'UNDERLINE' },
// { label: 'Monospace', style: 'CODE' }

const INLINE_STYLES = [
  {
    label: (
      <>
        <Icon size='md' color='grey-light' type='bold' />
        <Translate content='bold' />
      </>
    ),
    style: 'BOLD'
  },
  {
    label: (
      <>
        <Icon size='md' color='grey-light' type='italic' />
        <Translate content='italic' />
      </>
    ),
    style: 'ITALIC'
  }
];

export const InlineStyleControls = (props) => {
  const currentStyle = props.editorState.getCurrentInlineStyle();
  return (
    <div>
      {
        INLINE_STYLES.map(type =>
          <StyleButton
            key={type.style}
            active={currentStyle.has(type.style)}
            label={type.label}
            onToggle={props.onToggle}
            style={type.style}
          />
        )
      }
    </div>
  );
};

export default InlineStyleControls;
